/// <amd-module name="Feed/Legacy/Types/IFeedUser" />
export interface IFeedUser {
    identityDescriptors: string;
    canAdministerFeeds: boolean;
    canCreateFeed: boolean;
    isAnonymousOrPublic: boolean;
}
